// Components
import { Form, Head } from '@inertiajs/react';
import TextLink from '@/theme1/components/text-link';
import { Button } from '@/theme1/components/ui/button';
import { Spinner } from '@/theme1/components/ui/spinner';

export default function VerifyEmail({ status }: { status?: string }) {
    return (
        <>
            <Head title="Email verification" />

            <div className="mb-8 text-center">
                <div className="mx-auto flex size-20 items-center justify-center rounded-full bg-emerald-50 text-3xl text-emerald-700">✓</div>
                <h2 className="mt-6 text-4xl font-black uppercase tracking-[-0.04em]">Check your inbox</h2>
                <p className="mx-auto mt-3 max-w-sm text-sm leading-6 text-neutral-500">Verify your email to secure your membership and unlock the complete Captex account experience.</p>
            </div>

            {status === 'verification-link-sent' && (
                <div className="mb-4 text-center text-sm font-medium text-green-600">
                    A new verification link has been sent to the email address
                    you provided during registration.
                </div>
            )}

            <Form action="/admin/email/verification-notification" method="post" className="space-y-6 text-center">
                {({ processing }) => (
                    <>
                        <Button disabled={processing} variant="secondary">
                            {processing && <Spinner />}
                            Resend verification email
                        </Button>

                        <TextLink
                            href="/admin/logout"
                            className="mx-auto block text-sm"
                        >
                            Log out
                        </TextLink>
                    </>
                )}
            </Form>
        </>
    );
}

VerifyEmail.layout = {
    title: 'Email verification',
    description:
        'Please verify your email address by clicking on the link we just emailed to you.',
};
